import { Box } from '@looker/components';
import { globalTheme } from '@pulsepointinc/bi-components';
import styled, { keyframes } from 'styled-components';

export const StyledUserMessageBubble = styled(Box)`
  align-self: flex-end;
  padding: 12px;
  border-radius: 12px;
  background-color: ${globalTheme.colors.primary100};
`;

const loadingFade = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
`;

export const StyledTypingBubble = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${globalTheme.colors.primary100};
  padding: 12px 16px;
  border-radius: 12px;
`;

export const StyledTypingDot = styled(Box)<{ delay: string }>`
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background: ${globalTheme.colors.primary500};
  border-radius: 50%;
  opacity: 0;
  animation: ${loadingFade} 1s infinite;
  animation-delay: ${(props) => props.delay};
`;
